import { styled, createElement, composedProps, useTheme } from '@vebox/etui-system';
import { useState, createElement as createElement$1, cloneElement } from 'react';
import { getStyleProp } from '../utilities/get-styleprop.js';
import { b as _extends, d as _objectDestructuringEmpty, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Article as Article$1, Div } from '@vebox/etui-system-elements';

const Article = styled(Article$1).attrs(({
  theme
}) => ({
  display: 'flex',
  position: 'relative',
  overflow: 'hidden',
  height: '100%',
  width: '100%',
  mt: [`calc(-${theme.shape.headerBottomHeight + theme.shape.headerBottomHeight}px)`, `calc(-${theme.shape.headerTopHeight + theme.shape.headerBottomHeight}px)`],
  pt: [`calc(${theme.shape.headerBottomHeight + theme.shape.headerBottomHeight}px)`, `calc(${theme.shape.headerTopHeight + theme.shape.headerBottomHeight}px)`]
}))`
  backface-visibility: hidden;
  will-change: overflow;
`;

const ContentDiv = styled(Div)`
  overflow: auto;
  height: auto;
  width: 100%;
`;

const MainElement = createElement('main');
const Main = styled(MainElement)(composedProps);
const LayoutMain = styled(Main).attrs(_ref => {
  let props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return _objectSpread2({
    display: 'block',
    width: '100%',
    height: '100%',
    overflow: 'hidden'
  }, props);
})``;

function Layout({
  header,
  sideMenu,
  children,
  isScrollableContent = true,
  styles = {}
}) {
  const theme = useTheme();
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const onSideMenuToggle = () => {
    setIsSideMenuOpen(prevState => !prevState);
  };
  const onSideMenuClose = () => {
    setIsSideMenuOpen(false);
  };
  const getOverrideStyleProp = key => {
    return getStyleProp(key, styles, theme);
  };
  const renderSideMenu = () => {
    if (sideMenu) {
      return /*#__PURE__*/cloneElement(sideMenu, {
        isSideMenuOpen,
        toggleSideMenu: onSideMenuToggle,
        closeSideMenu: onSideMenuClose
      });
    }
    return null;
  };
  const hasSideMenu = !!sideMenu;
  return /*#__PURE__*/createElement$1(LayoutMain, getOverrideStyleProp('root'), header ? /*#__PURE__*/cloneElement(header, {
    isSideMenuOpen,
    hasSideMenu,
    toggleSideMenu: onSideMenuToggle,
    closeSideMenu: onSideMenuClose
  }) : null, renderSideMenu(), isScrollableContent ? /*#__PURE__*/createElement$1(Article, null, /*#__PURE__*/createElement$1(ContentDiv, null, children)) : children);
}

export default Layout;
